import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import DownloadIcon from '@mui/icons-material/Download';
import CircularProgress from '@mui/material/CircularProgress';

interface InfographicLightboxProps {
  src: string;
  alt?: string;
  onClose: () => void;
  onDownloadImage: () => void;
  isDownloadingImage: boolean;
}

export const InfographicLightbox: React.FC<InfographicLightboxProps> = ({
  src,
  alt = 'Infographic',
  onClose,
  onDownloadImage,
  isDownloadingImage,
}) => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        onClose();
      }
    };

    window.addEventListener('keydown', handleEscape, true);
    return () => window.removeEventListener('keydown', handleEscape, true);
  }, [onClose]);

  return createPortal(
    <div className="image-lightbox-overlay" data-modal-root="true" onClick={onClose}>
      <div className="image-lightbox-content" style={{ flexDirection: 'column' }} onClick={e => e.stopPropagation()}>
        <button className="image-lightbox-close" onClick={onClose}>×</button>
        {!isLoaded && (
          <div style={{ color: 'white', fontSize: '1rem' }}>Loading...</div>
        )}
        <img
          src={src}
          alt={alt}
          className="image-lightbox-img"
          style={{ display: isLoaded ? undefined : 'none' }}
          onLoad={() => setIsLoaded(true)}
        />
        {isLoaded && (
          <button
            className="slide-lightbox-download"
            style={{ marginTop: 16 }}
            onClick={onDownloadImage}
            disabled={isDownloadingImage}
            title={isDownloadingImage ? 'Downloading...' : 'Download Image'}
          >
            {isDownloadingImage ? (
              <CircularProgress size={14} color="inherit" />
            ) : (
              <DownloadIcon style={{ fontSize: 16 }} />
            )}
            {isDownloadingImage ? 'Downloading...' : 'Download Image'}
          </button>
        )}
      </div>
    </div>,
    document.body
  );
};
